import React, { useState } from 'react';
import Final from './final';
import FormComp from './formcomp';

interface Iprops {
  location?: string
}

function CollectionInfo(props: Iprops) {

  const {
    location,
  } = props
  let [isFinal, setIsFinal] = useState(false)

  return (
    <div>
      {
        !isFinal ?
          <FormComp
            onClose={setIsFinal}
            location={location}
          />
          :
          <Final />
      }
    </div>
    
  )
}

export default CollectionInfo;
